import type { SelectChangeEvent } from '@mui/material/Select';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import * as React from 'react';

import { appStore } from '../stores/AppStore';

const links = new Map<string, string>([
    [
        'OneDrive - Panorama (png)',
        'https://egregr1-my.sharepoint.com/:i:/g/personal/prohm_egregr1_onmicrosoft_com/EcRqQtCha9xIjNoGx3oitF4Bbm8cihlpBxXgHcZCE7HSMw?e=dT9FfI',
    ],
    [
        'OneDrive - usdz',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/EZckc_TQv75GgG0mtpCrtbEBAyEjlO_S0GBB6HLElHhZpw?e=R0es4I',
    ],
    [
        'OneDrive - eimg',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/EQ1OTN0fgWhEqao8ODblvhsBOpmWDhpO1Afk_L1y9ry_oA?e=jt4y1I',
    ],
    [
        'OneDrive - epan',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/ES8ZOvDwldhJs8eXYyN3kZ8BMZuXgNUclyt23L1DFfP0vw?e=oqUF6u',
    ],
    [
        'OneDrive - pec',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/EeJxibd0ZypOr5VLfPewp2oB-GEoR9Fq_QyF8c2Ujigyxw?e=3ytrg2',
    ],
    [
        'OneDrive - glb',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/EXj2RkYkYohDi9ulAjFpx7EBx3IFMyinzlDFQwcGbUIwhg?e=JAMhqx',
    ],
    [
        'OneDrive - glb',
        'https://egregr1-my.sharepoint.com/:u:/g/personal/prohm_egregr1_onmicrosoft_com/EYGX4wGcqpdHn0fsJ_8WTG0BrZtmB_ZY4hRJrKyMbuJyVw?e=lKcfvK',
    ],
    ['Google Drive - Panorama (png)', 'https://drive.google.com/file/d/16UXIagwdBNScN2aRhLEEUf3otZJWc6Li/view?usp=sharing'],
    ['Google Drive - eimg', 'https://drive.google.com/file/d/13mW3v-0XQozviMzocyiAezxbmGAVEKQP/view?usp=sharing'],
    ['Google Drive - epan', 'https://drive.google.com/file/d/1_067D-bu0AHvkn697VmL33RywsfFOTt6/view?usp=sharing'],
    ['Google Drive - pec', 'https://drive.google.com/file/d/1aaDY1oO4anmWZO3tU5PwB3F0j1doEoBz/view?usp=sharing'],
    ['Google Drive - glb', 'https://drive.google.com/file/d/19tahQnP2sw6mnvm600TMSGwOg8T__RNw/view?usp=sharing'],
    ['Google Drive - iar', 'https://drive.google.com/file/d/1FKSFy20_RhUmyP08F_8vqPM1pPv73TK1/view?usp=sharing'],

    ['Dropbox - Panorama (png)', 'https://www.dropbox.com/scl/fi/79m9zfdydpsvcrjs5jphr/impress_pano.png?rlkey=lxxp4titq6elygy115auctfi8&st=62a4gc97&dl=0'],
    ['Dropbox - eimg', 'https://www.dropbox.com/scl/fi/yhhqy42fx0f7arjoxt9e6/MCP-normal-8.8.eimg?rlkey=fky2b6zc76v02zkla736k1v09&st=8pimfcrn&dl=0'],
    ['Dropbox - epan', 'https://www.dropbox.com/scl/fi/clvk8g2s8qu0pa6qbsx6j/panorama.epan?rlkey=w2se3yuikr39d8v870w5rtxlh&st=hpds0ogg&dl=0'],
    ['Dropbox - pec', 'https://www.dropbox.com/scl/fi/1yha7qzr6qted3re54ywq/ahrend.pec?rlkey=bz3lmvlu4bojowrfy84qy5hj2&st=0d2penzg&dl=0'],
    ['Dropbox - glb', 'https://www.dropbox.com/scl/fi/amg3axr3353iyblbb7c6s/Kitchen-Planner8.glb?rlkey=qn8dt33lj9j1d1sr4m5ahrlrj&st=krj0w8ax&dl=0'],
    [
        'Dropbox - iar',
        'https://www.dropbox.com/scl/fi/1yftz9kml2mbq6ed1cwl6/Share_demo_2021-10-21_13-05-49.iar?rlkey=itjdtogi521zntwv9jrwquwj0&st=d74g9nvn&dl=0',
    ],

    // OWDS valid until xxx
    ['OWDS - Panorama (png)', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/709d3a46-e8c0-483e-aee1-bdf1b1e77469'],
    ['OWDS - eimg', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/a4c7a08b-42b8-47b7-a883-c9ce28340d72'],
    ['OWDS - epan', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/499a9a47-f61b-41c5-81ab-dcce03aaa4cd'],
    ['OWDS - pec', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/06ae3c01-508e-44b6-9733-ccf92a3381dc'],
    ['OWDS - glb', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/943d7a3a-5ebd-480d-845a-20c6ac6d6c5e'],
    ['OWDS - iar', 'https://owds.pcon-solutions.com/api/v1/shared_files/files/36bd24b9-901a-4a34-8224-b73c8eb991da'],
]);

export const DebugFiles: React.FC = () => {
    const [currentValue, setCurrentValue] = React.useState<string>('');
    if (links.size === 0) {
        return null;
    }

    const onChange: (event: SelectChangeEvent) => Promise<void> = async (event) => {
        setCurrentValue(event.target.value);
        try {
            const link = links.get(event.target.value)!;
            await appStore.setFileUrl(link);
            window.history.pushState('', '', '?url=' + encodeURIComponent(link));

            await appStore.fetchUrlInfo();
        } catch (error) {
            console.error('error updating URL:', error);
        }


    };
    return (
        <React.Fragment>
            <Select
                sx={{ color: 'white' }}
                onChange={onChange}
                value={currentValue}
                label="Links"
            >
                {[...links].map(([key]) => {
                    return (
                        <MenuItem
                            key={key}
                            value={key}
                        >
                            {key}
                        </MenuItem>
                    );
                })}
            </Select>
        </React.Fragment>
    );
};
